import React from "react";
import "./ValtraButton.scss";

const ValtraButton = React.memo(({ icon, label, className, ...rest }) => {
  return (
    <div
      className={`ValtraButton${icon ? " with-icon" : ""}${
        label ? " with-label" : ""
      }${className ? ` ${className}` : ""}`}
      {...rest}
    >
      <div className="ValtraButton_icon">{icon}</div>
      <div className="ValtraButton_label">{label}</div>
    </div>
  );
});

export default ValtraButton;
